// The Chat orders list's filters and the service query they make. Filters are non-personal, so they
// may sit in the URL. Chat orders are the battery and charger orders the support bot placed in chat.

// The part order statuses of the warranty service (warranty.part_order.status).
export const STATUS_FILTERS = [
  "offered",
  "placing",
  "awaiting_payment",
  "paid",
  "placed",
  "refused",
  "refunding",
  "refunded",
  "cancelled",
];
export const PAGE_SIZE = 25;

export const DEFAULT_FILTERS = { status: "", from: "", to: "" };

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const isoDate = (value) => (typeof value === "string" && ISO_DATE.test(value) ? value : "");
const oneOf = (value, allowed) => (allowed.includes(value) ? value : "");

export const filtersFromParams = (params) => {
  const from = isoDate(params.get("from"));
  const to = isoDate(params.get("to"));
  return {
    status: oneOf(params.get("status"), STATUS_FILTERS),
    // A reversed range is dropped rather than sent: the service would refuse it.
    from: from && to && from > to ? "" : from,
    to,
  };
};

// Only the set values, so the plain list has a plain URL.
export const filtersToParams = (filters) => {
  const out = {};
  ["status", "from", "to"].forEach((key) => {
    if (filters[key]) out[key] = filters[key];
  });
  return out;
};

// The query keys of the part order list (the country is added by warrantyApi). The service refuses
// unknown keys, so only set ones go; "any status" sends no status at all.
export const listQuery = (filters, cursor, limit = PAGE_SIZE) => {
  const out = { ...filtersToParams(filters), limit };
  if (cursor) out.cursor = cursor;
  return out;
};
